(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["link-section"] && !Shopify.designMode) return;
  try {
    
// 在这里添加任何需要的JavaScript代码

  } catch(e) { console.error(e); }
})();
})();
